/* Site-wide behaviour analytics: one plain event per action, no parameters
   (merchant request 2026-10-08). Every event shows up directly in GA → Reports
   → Engagement → Events with its own count, without custom dimensions or
   Explore. So "which size", "which section" and "how long" are baked into the
   event name: size_select_xl, section_view_product, section_time_product_15s.

   Everything goes through Shopify's Customer Events bus
   (Shopify.analytics.publish), never straight to a vendor. That keeps the
   theme vendor-free and lets Shopify enforce the shopper's consent choice. Any
   pixel under Settings → Customer events receives these alongside Shopify's
   standard events (page_viewed, product_added_to_cart, checkout_started,
   checkout_completed, …). The GA4 forwarding pixel is in the outer repo:
   analytics/custom-pixel.js.

   Automatic, no markup needed:
   - section_view_<section>         first time each homepage section reaches mid-screen
   - section_time_<section>_<N>s    once the section has been at mid-screen for a
                                    total of 5 / 15 / 30 / 60 seconds this visit
   - <channel>_click_<section>      every link: whatsapp / instagram / email /
                                    account / policy / jump / outbound / link
   - video_<section>_<N>            25 / 50 / 75 / 100 % of the first loop of a
                                    non-background video
   - checkout_click                 any Check out button (cart drawer)
   Section scripts add their own via window.prTrack("event_name")
   (pr-product-showcase.js, pr-everything-it-carries.js). Put
   data-pr-track="event_name" on a link or button to give its click its own
   name instead.

   GA4 rules for names: letters, digits and underscores, starting with a letter,
   at most 40 characters. prTrack enforces this. */
(function () {
  // Short names for the homepage sections, keyed by the section id in
  // templates/index.json. Unlisted sections fall back to the id without "pr_"
  // and its underscores ("pr_new_thing" → "newthing").
  var SECTION_NAMES = {
    pr_hero: "hero",
    pr_product_showcase: "product",
    pr_everything_it_carries: "carries",
    pr_built_different: "compartments",
    pr_stop_motion: "stopmotion",
    pr_technical_drawing: "drawing",
    pr_statement: "statement",
    pr_features: "features",
    pr_get_in_touch: "contact",
    pr_header: "header",
    pr_footer: "footer"
  };

  // Horizon wraps each section as "shopify-section-template--123__pr_hero".
  function sectionName(el) {
    var wrapper = el.closest(".shopify-section");
    if (!wrapper) {
      return "page";
    }
    var parts = wrapper.id.split("__");
    var key = parts[parts.length - 1].replace(/^shopify-section-/, "");
    return SECTION_NAMES[key] || key.replace(/^pr[_-]/, "").replace(/[^a-z0-9]/gi, "").toLowerCase();
  }
  window.prSectionName = sectionName;

  // "Stiff Sleeve Compartment" → "stiff_sleeve_compartment".
  window.prSlug = function (text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  };

  window.prTrack = function (name) {
    var eventName = prSlug(name).slice(0, 40);
    // Unpublished/preview themes log only, so trying out a redesign doesn't
    // skew the live site's numbers.
    var isLiveTheme = window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main";
    if (!isLiveTheme) {
      console.debug("[pr-analytics] (not sent, preview theme)", eventName);
      return;
    }
    // Shopify.analytics comes from content_for_header and can be missing on
    // some Shopify-rendered previews; tracking is skipped there.
    if (!window.Shopify.analytics || !window.Shopify.analytics.publish) {
      console.debug("[pr-analytics] (not sent, no Shopify.analytics)", eventName);
      return;
    }
    window.Shopify.analytics.publish(eventName, {});
    console.debug("[pr-analytics]", eventName);
  };

  function linkChannel(href) {
    if (/^mailto:/i.test(href)) {
      return "email";
    }
    if (/wa\.me|whatsapp\.com/i.test(href)) {
      return "whatsapp";
    }
    if (/instagram\.com|ig\.me/i.test(href)) {
      return "instagram";
    }
    var url = new URL(href, location.href);
    if (url.origin !== location.origin) {
      return /shopify\.com\/\d+\/account/.test(href) ? "account" : "outbound";
    }
    if (url.pathname === location.pathname && url.hash) {
      return "jump";
    }
    if (/^\/(account|customer_authentication)/.test(url.pathname)) {
      return "account";
    }
    if (/^\/policies\//.test(url.pathname)) {
      return "policy";
    }
    return "link";
  }

  // Capture phase so it still fires when a section's own handler stops propagation.
  document.addEventListener(
    "click",
    function (e) {
      var named = e.target.closest("[data-pr-track]");
      if (named) {
        prTrack(named.getAttribute("data-pr-track"));
        return;
      }
      if (e.target.closest('[name="checkout"], a[href^="/checkout"]')) {
        prTrack("checkout_click");
        return;
      }
      var link = e.target.closest("a[href]");
      if (link) {
        prTrack(linkChannel(link.getAttribute("href")) + "_click_" + sectionName(link));
      }
    },
    true
  );

  function watchSections() {
    if (!("IntersectionObserver" in window)) {
      console.warn("[pr-analytics] no IntersectionObserver, section views not tracked");
      return;
    }
    var TIME_MARKS = [5, 15, 30, 60];
    var seen = {};
    var totalMs = {};
    var activeSince = {};
    var sentMarks = {};

    function bank(name) {
      totalMs[name] = (totalMs[name] || 0) + (Date.now() - activeSince[name]);
      delete activeSince[name];
    }

    // Once a second, turn time-at-mid-screen into the next 5/15/30/60s event.
    setInterval(function () {
      Object.keys(activeSince).forEach(function (name) {
        var seconds = ((totalMs[name] || 0) + (Date.now() - activeSince[name])) / 1000;
        sentMarks[name] = sentMarks[name] || {};
        TIME_MARKS.forEach(function (mark) {
          if (seconds >= mark && !sentMarks[name][mark]) {
            sentMarks[name][mark] = true;
            prTrack("section_time_" + name + "_" + mark + "s");
          }
        });
      });
    }, 1000);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var name = sectionName(entry.target);
          if (!entry.isIntersecting) {
            if (activeSince[name]) {
              bank(name);
            }
            return;
          }
          if (document.visibilityState === "visible") {
            activeSince[name] = Date.now();
          }
          if (!seen[name]) {
            seen[name] = true;
            prTrack("section_view_" + name);
          }
        });
      },
      // "Viewed" = the section reaches the middle fifth of the screen. A ratio
      // threshold would never fire for sections taller than the viewport.
      { threshold: 0, rootMargin: "-40% 0px -40% 0px" }
    );
    document.querySelectorAll("#MainContent > .shopify-section").forEach(function (section) {
      observer.observe(section);
    });

    // The clock only runs while the page is actually on screen.
    var paused = [];
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        paused = Object.keys(activeSince);
        paused.forEach(bank);
      } else {
        paused.forEach(function (name) {
          activeSince[name] = Date.now();
        });
        paused = [];
      }
    });
  }

  // Background loops (hero, marked data-pr-autoplay-video) are scenery, not content.
  function watchVideos() {
    document.querySelectorAll("#MainContent video:not([data-pr-autoplay-video])").forEach(function (video) {
      var name = sectionName(video);
      var sent = {};
      var lastTime = 0;
      function mark(percent) {
        if (!sent[percent]) {
          sent[percent] = true;
          prTrack("video_" + name + "_" + percent);
        }
      }
      video.addEventListener("timeupdate", function () {
        if (!video.duration) {
          return;
        }
        // A loop restarting drops currentTime back near 0 — only the first pass counts.
        if (video.currentTime < lastTime - 1) {
          mark(100);
        }
        lastTime = video.currentTime;
        var percent = (video.currentTime / video.duration) * 100;
        [25, 50, 75].forEach(function (m) {
          if (percent >= m) {
            mark(m);
          }
        });
      });
    });
  }

  function start() {
    watchSections();
    watchVideos();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
